import { fieldsConfigAdmin } from "./forms/leadFields";
import { fieldLabels } from "./forms/fieldsLabels";

export const LEAD_FIELD_ACCESS_TAB_KEY = 'leadFieldAccess';

export const LEAD_FIELD_ACCESS_MODE = {
    HIDE: 'hide',
    VIEW: 'view',
    EDIT: 'edit',
};

const LEAD_FIELD_ACCESS_DEFAULT_MODES = {
    phone: LEAD_FIELD_ACCESS_MODE.HIDE,
};

const LEAD_FIELD_ACCESS_HIDDEN_KEYS = new Set(['ai_trading']);
const LEAD_FIELD_ACCESS_CONFIG_KEYS = new Set(['bot_profit_percent']);
const LEAD_FIELD_ACCESS_EXTRA_FIELDS = [
    {
        key: 'trading_access_blocked',
        section: 'config',
        label: {
            ru: 'Доступ к торговле',
            en: 'Trading Access',
        },
    },
];

const leadFieldAccessSectionLabels = {
    ru: {
        general: 'Общая информация',
        config: 'Конфиг',
        kycSales: 'KYC Продажи',
        kycRetention: 'KYC Удержание',
        hide: 'Hide',
        view: 'View',
        edit: 'Edit',
    },
    en: {
        general: 'General Info',
        config: 'Config',
        kycSales: 'KYC Sales',
        kycRetention: 'KYC Retention',
        hide: 'Hide',
        view: 'View',
        edit: 'Edit',
    },
};

const getBaseLeadFieldAccessSections = () => {
    const sections = {
        general: [],
        config: [],
        kycSales: [],
        kycRetention: [],
    };
    const renderedKeys = new Set();

    fieldsConfigAdmin.forEach((field) => {
        if (field.detailsStatus !== 'active' || renderedKeys.has(field.key) || LEAD_FIELD_ACCESS_HIDDEN_KEYS.has(field.key)) {
            return;
        }

        if (field.key.startsWith('kyc_sales_')) {
            sections.kycSales.push(field);
        } else if (field.key.startsWith('kyc_retention_')) {
            sections.kycRetention.push(field);
        } else if (LEAD_FIELD_ACCESS_CONFIG_KEYS.has(field.key)) {
            sections.config.push(field);
        } else {
            sections.general.push(field);
        }

        renderedKeys.add(field.key);
    });

    LEAD_FIELD_ACCESS_EXTRA_FIELDS.forEach((field) => {
        if (renderedKeys.has(field.key)) {
            return;
        }

        sections[field.section]?.push(field);
        renderedKeys.add(field.key);
    });

    return sections;
};

export const getLeadFieldAccessSections = (langSelected = 'ru') => {
    const labels = fieldLabels[langSelected] || fieldLabels.ru;
    const sectionLabels = leadFieldAccessSectionLabels[langSelected] || leadFieldAccessSectionLabels.ru;
    const sections = getBaseLeadFieldAccessSections();

    return Object.entries(sections)
        .map(([sectionKey, fields]) => ({
            key: sectionKey,
            label: sectionLabels[sectionKey] || sectionKey,
            fields: fields.map((field) => ({
                key: field.key,
                label: labels[field.key] || field.label?.[langSelected] || field.label?.ru || field.label,
            })),
        }))
        .filter((section) => section.fields.length > 0);
};

export const getLeadFieldAccessOptions = (langSelected = 'ru') => {
    const labels = leadFieldAccessSectionLabels[langSelected] || leadFieldAccessSectionLabels.ru;

    return [
        { value: LEAD_FIELD_ACCESS_MODE.HIDE, label: labels.hide },
        { value: LEAD_FIELD_ACCESS_MODE.VIEW, label: labels.view },
        { value: LEAD_FIELD_ACCESS_MODE.EDIT, label: labels.edit },
    ];
};

export const createDefaultLeadFieldAccessModes = () => {
    const sections = getBaseLeadFieldAccessSections();

    return Object.values(sections)
        .flat()
        .reduce((acc, field) => {
            acc[field.key] = LEAD_FIELD_ACCESS_DEFAULT_MODES[field.key] || LEAD_FIELD_ACCESS_MODE.EDIT;
            return acc;
        }, {});
};

export const normalizeLeadFieldAccessModes = (leadFieldAccess = {}) => {
    const defaults = createDefaultLeadFieldAccessModes();

    return Object.keys(defaults).reduce((acc, key) => {
        const nextValue = leadFieldAccess?.[key];
        acc[key] = Object.values(LEAD_FIELD_ACCESS_MODE).includes(nextValue) ? nextValue : defaults[key];
        return acc;
    }, {});
};

export const hasCustomLeadFieldAccessModes = (leadFieldAccess = {}) => {
    const normalizedModes = normalizeLeadFieldAccessModes(leadFieldAccess);
    const defaultModes = createDefaultLeadFieldAccessModes();

    return Object.keys(defaultModes)
        .some((key) => normalizedModes[key] !== defaultModes[key]);
};

export const getLeadFieldAccessMode = (leadFieldAccess = {}, key) => {
    const normalizedModes = normalizeLeadFieldAccessModes(leadFieldAccess);
    return normalizedModes[key] || LEAD_FIELD_ACCESS_MODE.EDIT;
};
